import Fab from "@mui/material/Fab";
import { styled } from "@mui/system";

export const FloatingButtonWrapper = styled(Fab)({
  width: 28,
  height: 28,
  minHeight: 0,
  minWidth: 0,
  fontSize: "0.75rem",
  backgroundColor: "#1976d2",
  color: "white",
  padding: 0,
  lineHeight: 1,
});
